import ChannelIcon from "../../components/ChannelIcon.js";
import {CHANNEL_SORT_PRIORITY} from "../../enums/channel.js";
import {request} from "../../utils/request/index.js";
import {useRequest} from "../../../__snowpack__/pkg/ahooks.js";
import {Space} from "../../../__snowpack__/pkg/antd.js";
import React from "../../../__snowpack__/pkg/react.js";
export default function useQueryChannels(options) {
  const result = useRequest((params) => request.get("/saas/shop/channels", params), options);
  const {data: _channels = []} = result;
  const channels = _channels.sort((a, b) => {
    return (CHANNEL_SORT_PRIORITY[a.id] ?? -1) - (CHANNEL_SORT_PRIORITY[b.id] ?? -1);
  });
  const _options = channels.map((channel) => ({
    label: /* @__PURE__ */ React.createElement(Space, {
      align: "center"
    }, /* @__PURE__ */ React.createElement(ChannelIcon, {
      channelId: channel.id
    }), channel.name),
    value: channel.id
  }));
  const tagsOptions = channels.map((channel) => ({
    text: channel.name,
    key: channel.id
  }));
  return {...result, channels, options: _options, tagsOptions};
}
